module.exports = __webpack_public_path__ + "img/GA.f17d42cd.svg";